import { Component } from '@mycolorway/tao';
import Group from './group';

Component('tr-project-progress-group', {
  extends: [Group],

});
